<script>
  export let text = "";
  let copied = false;

  function copyToClipboard() {
    navigator.clipboard.writeText(text).then(() => {
      copied = true;
      setTimeout(() => {
        copied = false;
      }, 2000);
    });
  }
</script>

<button
  class="copy_button"
  title="Copy to clipboard"
  class:copied
  on:click={copyToClipboard}
>
  {text}
</button>

<style>
  .copy_button {
    border: 1px solid #0353e9;
    padding: 0.5rem 1rem;
    color: #0353e9;
  }

  .copy_button:hover {
    background-color: #0353e9;
    color: white;
  }

  .copy_button.copied {
    border: 1px solid #4caf50;
    padding: 0.5rem 1rem;
    color: #4caf50;
  }

  .copy_button.copied:hover {
    background-color: #4caf50;
    color: white;
    border-color: #4caf50;
  }
</style>
